import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { exitFloorplanOperation } from 'spw-redux/modules/floorplan/actions';

const useCheckFloorplanOperationBeforeCalling = (
  callback: (args?: any) => void
) => {
  const dispatch = useDispatch();

  return useCallback(
    (args?: any) => {
      dispatch(exitFloorplanOperation(() => callback(args)));
    },
    [callback, dispatch]
  );
};

export default useCheckFloorplanOperationBeforeCalling;
